/**
 * BrandMark — the Brain bolt logo as an inline SVG.
 * Inherits `currentColor`, so colour it via a `text-*` class on a parent.
 * Used by the top bar and the auth shell.
 */

export interface BrandMarkProps {
  /** Square edge length in px. */
  size?: number;
  className?: string;
}

export function BrandMark({ size = 18, className }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M13 2 3 14h9l-1 8 10-12h-9z" />
    </svg>
  );
}
